var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"bottom-right",on:{"click":_vm.scrollTop}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }